export interface AnonymousSession {
    cultureCode: string;
    languageCode: string;
    sessionId: string;
}

export interface LoggedInSession extends AnonymousSession {
    accessToken: string;
    currentEnterpriseId: string | null;
    currentProfileId: string;
}

export type Session = LoggedInSession | AnonymousSession;

export function isLoggedInSession(session: Session): session is LoggedInSession {
    return (session as LoggedInSession).currentProfileId !== undefined;
}
